import { render, staticRenderFns } from "./DatasItems.vue?vue&type=template&id=6fd1c8fe&scoped=true"
import script from "./DatasItems.vue?vue&type=script&lang=ts"
export * from "./DatasItems.vue?vue&type=script&lang=ts"
import style0 from "./DatasItems.vue?vue&type=style&index=0&id=6fd1c8fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd1c8fe",
  null
  
)

export default component.exports